import React, { useEffect, useState } from "react";
import { fnUploadLicense, fnGetLicenseInfo } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";

const LicenseUpload: React.FC = () => {
  const [licenseFile, setLicenseFile] = useState<File | null>(null);
  const [signatureFile, setSignatureFile] = useState<File | null>(null);
  const [publicKeyFile, setPublicKeyFile] = useState<File | null>(null);
  const [message, setMessage] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [licenseInfo, setLicenseInfo] = useState<any>(null);

  const handleUpload = async () => {
    if (!licenseFile || !signatureFile || !publicKeyFile) {
      setError("⚠️ 모든 파일(라이선스, 서명, 공개키)을 선택해주세요.");
      setMessage("");
      return;
    }

    const result = await fnUploadLicense(
      licenseFile,
      signatureFile,
      publicKeyFile
    );

    if (result.startsWith("업로드 중 오류") || result.startsWith("❌")) {
      setError(result);
      setMessage("");
    } else {
      setMessage("✅ " + result);
      setError("");
      fetchLicenseInfo();
    }
  };

  const fetchLicenseInfo = async () => {
    const res = await fnGetLicenseInfo();
    setLicenseInfo(res);
  };

  useEffect(() => {
    fetchLicenseInfo();
  }, []);

  return (
    <div className="flex justify-center items-start min-h-screen bg-gray-100 p-10">
      <div className="bg-white shadow-md rounded-2xl p-8 w-full max-w-4xl flex gap-8">
        {/* 왼쪽: 업로드 박스 */}
        <div className="flex-1">
          <h2 className="text-2xl font-bold mb-6 text-center text-blue-900">
            License Upload
          </h2>

          <div className="mb-4">
            <label className="block font-semibold mb-1">
              License File (.json)
            </label>
            <input
              type="file"
              accept=".json"
              onChange={(e) => setLicenseFile(e.target.files?.[0] || null)}
              className="w-full border rounded px-3 py-2"
            />
          </div>

          <div className="mb-4">
            <label className="block font-semibold mb-1">
              Signature File (.sig)
            </label>
            <input
              type="file"
              accept=".sig"
              onChange={(e) => setSignatureFile(e.target.files?.[0] || null)}
              className="w-full border rounded px-3 py-2"
            />
          </div>

          <div className="mb-4">
            <label className="block font-semibold mb-1">
              Public Key File (.pem)
            </label>
            <input
              type="file"
              accept=".pem"
              onChange={(e) => setPublicKeyFile(e.target.files?.[0] || null)}
              className="w-full border rounded px-3 py-2"
            />
          </div>

          <button
            onClick={handleUpload}
            className="w-full bg-blue-900 text-white font-bold py-2 rounded hover:bg-blue-800"
          >
            Upload
          </button>

          {error && (
            <p className="mt-4 text-red-600 text-sm text-center">{error}</p>
          )}
          {message && (
            <p className="mt-4 text-green-600 text-sm text-center">{message}</p>
          )}
        </div>

        {/* 오른쪽: 현재 등록된 라이선스 정보 */}
        <div className="flex-1">
          <h3 className="text-lg font-semibold mb-2 border-b pb-2">
            📄 현재 등록된 라이선스 정보
          </h3>
          {licenseInfo ? (
            <table className="w-full text-sm border border-gray-200 rounded bg-gray-50">
              <tbody>
                <tr className="border-b">
                  <td className="px-3 py-2 font-semibold text-right w-1/3">
                    회사명
                  </td>
                  <td className="px-3 py-2">{licenseInfo.company}</td>
                </tr>
                <tr className="border-b">
                  <td className="px-3 py-2 font-semibold text-right">
                    사업자번호
                  </td>
                  <td className="px-3 py-2">{licenseInfo.bizNo}</td>
                </tr>
                <tr className="border-b">
                  <td className="px-3 py-2 font-semibold text-right">
                    유효기간
                  </td>
                  <td className="px-3 py-2">{licenseInfo.validUntil}</td>
                </tr>
                <tr>
                  <td className="px-3 py-2 font-semibold text-right">
                    서비스유형
                  </td>
                  <td className="px-3 py-2">{licenseInfo.serviceType}</td>
                </tr>
              </tbody>
            </table>
          ) : (
            <p className="text-gray-500">라이선스 정보가 없습니다.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LicenseUpload;
